exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SignupModal-closeIcon-6-XQJ{\n\theight: 30px;\n    margin-top: -5px;\n    margin-left: -7px;\n    background: var(--icon-bg-color);\n    border-radius: 20px;\n}", ""]);

// exports
exports.locals = {
	"closeIcon": "SignupModal-closeIcon-6-XQJ"
};